import { AuthUser } from 'app/provider/auth'

export type ViewableBy = 'guest' | 'fresher' | 'student'

export const isViewableBy = (viewableBy?: [ViewableBy], user?: AuthUser | null) => {
  // If no viewableBy is set, it is viewable by everyone (backwards compatibility)
  if (!viewableBy) {
    return true
  }

  if (!user) {
    return viewableBy.includes('guest')
  }

  return viewableBy.includes(user.userType as ViewableBy)
}
